import React, { useEffect } from 'react';
import Toggle from '../../Elements/Toggle';
import { toastr } from 'react-redux-toastr';
import HelpBallon from '../../Intelligence/component/HelpBalloon/HelpBalloon';

// import { Container } from './styles';

export default (props) => {
  const { toggleIa, item, bot, user } = props;

  const handleToggleIa = () => {
    if (bot.iaEnabled === false) {
      toastr.warning('Para utilizar este recurso é necessário ativar a IA.');
    }

    toggleIa();
  };

  return (
    <>
      <Toggle
        disabled={user && user.claim.name === 'Viewer' ? true : false}
        disabled={false}
        checked={!item.AILocal}
        onChange={() => {
          handleToggleIa();
        }}
      />
      <label>Usar IA Global</label>
      <HelpBallon
            id="help-ballon-check-agente"
            message="Ao ativar, além da interpretação local das intenções, serão respeitados condicionais cadastrados na aba de IA"
          />
    </>
  );
};
